import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<div class=\"flex animate-pulse flex-row items-center h-full justify-start p-3 space-x-5\"><div class=\"w-10 bg-gray-300 h-10 rounded-full\"></div><div class=\"flex flex-col space-y-3 w-full\"><div class=\"w-2/2 bg-gray-300 h-6 rounded-md\"></div><div class=\"w-1/2 bg-gray-300 h-6 rounded-md\"></div></div></div>", 1)
const _hoisted_2 = [
  _hoisted_1
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["w-full h-20 rounded-md mx-auto", [_ctx.size === 'lg' ? 'mt-20' : 'mt-2']])
  }, _hoisted_2, 2))
}